<script>
import api from "@modules/JourneyBuilder/api";
import {errorGrowl} from "@core/Util/growler";

import BrickCustomConditions from "../BrickCustomConditions";

export default {
    name: "TouchpointCustomConditions",
    
    props: {
        value: {
            type: Array,
            required: true
        },
        
        parentType: {
            type: String,
            required: true
        },
        
        subType: {
            type: String,
            required: false
        }
    },
    
    data() {
        return {
            isLoading: true,
            fields: []
        }
    },
    
    computed: {
        availableFields() {
            //A type is available when it is:
            // * Global (= no subTypes)
            // * Linked to our touchPointSubType (= subTypes contains our given touchPointSubType)
            return this.fields.filter(field => 
                !field.touchPointSubTypes.length || 
                field.touchPointSubTypes.includes(this.subType)
            );
        }
    },
    
    watch: {
        parentType() {
            this.loadTouchpointCustomFields();
        },
        
        isLoading(value) {
            this.$emit('loading-state-changed', value);
        }
    },
    
    created() {
        this.loadTouchpointCustomFields();
    },
    
    methods: {
        async loadTouchpointCustomFields() {
            this.isLoading = true;
            
            try {
                const { name, types } = await api.getCustomFields(this.parentType);
                
                //Guard against race conditions - parentType may have changed while waiting for our fields to load 
                if(name !== this.parentType) {
                    return;
                }
                
                this.fields = types;
            } catch (e) {
                errorGrowl(e);
                
                this.fields = [];
            } finally {
                this.isLoading = false;
            }
        },

        triggerValidations() {
            if(this.$refs.customConditions) {
                this.$refs.customConditions.triggerValidations();
            }
        }
    },

    render(createElement, context) {
        return createElement(BrickCustomConditions, {
            props: {
                fields: this.availableFields,
                value: this.value,
                /** @param {JourneyBuilder.CustomFieldDropdownValue} value */
                isSelectableDropdownValue: value => !value.touchPointSubType || value.touchPointSubType === this.subType,
                isLoading: this.isLoading
            },
            
            on: {
                input: $event => this.$emit('input', $event),
                
                'validation-state-changed': $event => this.$emit('validation-state-changed', $event)
            },
            
            ref: 'customConditions'
        })
    }
}
</script>
